/**
 * Os nomes das coleções do armazém.
 *
 * Vieram do Flutter, um por um (as constantes `_colecao` de cada repositório).
 * O nome é o contrato entre os dois apps: renomear aqui não migra nada, só
 * esconde o que já está gravado. Por isso a chave é em português e o valor
 * fica exatamente como o Flutter gravou.
 */
export const COLECOES = {
  // Casa e gente
  pessoas: 'users',
  perfis: 'perfis',
  presenca: 'presence',
  config: 'config',
  sugestoes: 'sugestoes',
  fcm: 'fcm_tokens',

  // O dia a dia
  humores: 'moods',
  marcos: 'milestones',
  notas: 'notes',
  potePrateado: 'starlight_jar',
  listaDesejos: 'bucket_list',
  agenda: 'calendar_events',
  galeria: 'gallery',
  jardim: 'garden_stats',
  xp: 'xp_progress',
  santuario: 'sanctuary_messages',

  // Cinema e leitura
  cinema: 'watch_list',
  livros: 'our_books',
  leitura: 'read_list',

  // Cozinha
  receitas: 'recipes',
  despensa: 'pantry',
  compras: 'shopping_lists',
  cardapio: 'week_menus',

  // Kovu
  fatos: 'ai_facts',
  conversas: 'ai_conversations',
  sessoes: 'ai_sessions',

  // Juntos ao vivo
  telaAoVivo: 'live_canvas',
  tracos: 'canvas_strokes',
  musica: 'music_status',
  salasVoz: 'voice_rooms',
  candidatosVoz: 'voice_candidates',
  salasSessao: 'watch_party_rooms',
  servidoresSessao: 'watch_party_servers',
  partidas: 'active_matches',
  salasTt: 'tt_rooms',
} as const;

/**
 * As coleções que este app conhece. O fluxo pode trazer uma que não está aqui
 * (o Flutter grava primeiro, a gente aprende depois), e por isso o tipo do
 * transporte em `dados.ts` continua sendo `string`.
 */
export type ColecaoConhecida = (typeof COLECOES)[keyof typeof COLECOES];
